var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordCorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7643 0.235294C10.45 -0.0784314 9.97857 -0.0784314 9.66428 0.235294L3.77143 6.11765L1.33571 3.68627C1.02143 3.37255 0.55 3.37255 0.235714 3.68627C-0.0785714 4 -0.0785714 4.47059 0.235714 4.78431L3.22143 7.76471C3.37857 7.92157 3.53571 8 3.77143 8C4.00714 8 4.16429 7.92157 4.32143 7.76471L10.7643 1.33333C11.0786 1.01961 11.0786 0.54902 10.7643 0.235294Z",
    fill: "#00B552"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordCorrect);
export default __webpack_public_path__ + "static/media/password_correct.42e22de9cf6ba31c1ac9552f1ea792d9.svg";
export { ForwardRef as ReactComponent };